import { Attributes, List, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class DocumentType extends ModelBase {
    static typeName = "DocumentType";

    public documentTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Document Type")
    public documentTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.documentTypeName) {
            return "New document type";
        } else {
            return this.documentTypeName;
        }
    }
}